import { Button } from "primereact/button"

const MainPageBody = () => {

    return (
        <>
            <div className="px-4 md:px-8 min-h-screen pb-8" style={{ maxWidth: "45rem" }}>
                <div className="flex flex-column justify-content-start align-items-start">
                    <img src="/Stamp.png" />
                    <div className="flex flex-column gap-5 z-5">
                        <p className="m-0 text-white" style={{ lineHeight: "5rem", fontSize: "4.25rem", fontWeight: 700, wordBreak: "break-word" }}>
                            Remote Physiotherapy Platform
                        </p>
                        <p className="m-0 text-xl" style={{ color: "white", textWrap: "wrap", fontFamily: "Poppins", maxWidth: "40rem" }}>
                            Thousands are turning to Mobithera to transform how we heal. With clinically guided, AI-personalized physical therapy, we help people regain strength, reduce pain, and make their lives easier.
                        </p>
                        <Button label="Book a Demo"
                            iconPos="right"
                            icon="pi pi-angle-right"
                            className="text-lg"
                            style={{
                                color: "white",
                                backgroundColor: "#E3506B",
                                borderRadius: "10px",
                                fontWeight: 700,
                                height: "3.25rem",
                                width: "13.125rem"
                            }} />
                    </div>
                </div>
            </div>
            <img
                src="/MainMenuMan.png"
                style={{ width: "60rem" }}
                className="hidden xl:block right-0 bottom-0 absolute flex-grow-1 z-0"
            />
        </>
    )
}

export default MainPageBody